<template>
    <v-dialog
        v-model="dialog"
        @click:outside="closeDialog"
        max-width="600px"
        scrollable
        zIndex="210"
    >
        <v-card v-if="dialog">
            <create-company-dialog @created="fillCompany" ref="createCompanyDialog"></create-company-dialog>
            <create-user-dialog @created="fillContact" ref="createUserDialog"></create-user-dialog>
            <v-toolbar flat dense>
                <h2 class="text-h6 text-primary-700 text-ellipsis-overflow">
                    <span>New Enquiry for </span>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <span v-on="on" class="text-dashed-underline ">{{ formatLabel(entity.label) }}</span>
                        </template>
                        <span>{{ entity.label }}</span>
                    </v-tooltip>
                </h2>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn> 
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="py-6">
                <v-row>
                    <v-col cols="12">
                        <v-combobox
                            outlined
                            dense
                            hide-details
                            v-model="form.selectedCompany"
                            :search-input.sync="search.company"
                            :error-messages="formErrors.companyContact ? 'Either contact or company is required' : ''"
                            :items="Companies"
                            label="Company"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            :loading="companiesLoading"
                            clearable
                            ref="companiesCombobox"
                            @update:search-input="searchCompanies($event)"
                        >
                            <template v-slot:append-outer>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon @click="$refs.createCompanyDialog.showDialog()" v-on="on">mdi-plus</v-icon>
									</template>
									<span>Create a new company</span>
								</v-tooltip>
							</template>
                        </v-combobox>
                        <div v-if="checkCompanySearch" style=" position: absolute;">No companies found. <a @click="$refs.createCompanyDialog.showDialog();">Create a new company</a></div>
                    </v-col>
                    <v-col cols="12">
                        <v-combobox
                            outlined
                            dense
                            hide-details
                            v-model="form.selectedContact"
                            :search-input.sync="search.contact"
                            :error-messages="formErrors.companyContact ? 'Either contact or company is required' : ''"
                            :items="Contacts"
                            label="Contact"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            :loading="contactsLoading"
                            clearable
                            ref="contactsCombobox"
                            @update:search-input="searchContacts($event)"
                        >
                            <template v-slot:append-outer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon @click="$refs.createUserDialog.showDialog()" v-on="on">mdi-plus</v-icon>
                                    </template>
                                    <span>Create a new contact</span>
                                </v-tooltip>
                            </template>
                        </v-combobox>
                        <div v-if="checkContactSearch" style=" position: absolute;">No contacts found. <a @click="$refs.createUserDialog.showDialog();">Create a new contact</a></div>
                    </v-col>
                </v-row>
                <v-divider class="my-8"></v-divider>
                <v-row>
                    
                    <v-col cols="12">
                        <!-- dropdown for stage -->
                        <v-select
                            outlined
                            dense
                            hide-details
                            v-model="form.stage"
                            :error-messages="formErrors.stage ? 'Stage is required' : ''"
                            :items="stageOptions"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            label="Stage"
                            clearable
                            @change="formErrors.stage = false"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <!-- dropdown for reason -->
                        <v-select
                            outlined
                            dense
                            hide-details
                            v-model="form.reason"
                            :error-messages="formErrors.reason ? 'Reason is required' : ''"
                            :items="reasonOptions"
                            :item-title="item => item.label"
                            :item-value="item => item.value"
                            :item-text="'label'"
                            label="Reason"
                            clearable
                            @change="formErrors.reason = false"
                        ></v-select>

                    </v-col>
                    <v-col cols="12">
                        <!-- <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.received_at"
                            v-validate="''"
                            :error-messages="errors.collect('form.received_at')"
                            placeholder="dd/mm/yyyy"
                            label="Received At"
                            data-vv-name="form.received_at"
                            data-vv-as="Received At"
                            mask="##/##/####"
                            v-mask="'##/##/####'"
                            append-icon="mdi-calendar"
                        ></v-text-field> -->
                        <date-input
                            v-model="form.received_at"
                            label="Received On"
                        ></date-input>
                    </v-col>
                </v-row>
                <h5 class="text-h7 mb-1 mt-4 pa-0">Size</h5>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            outlined
                            dense
                            v-model="form.from_size"
                            label="From (sqft)"
                            hide-details
                            append-icon="mdi-home"
                            return-masked-value
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            outlined
                            dense
                            v-model="form.size_from"
                            label="To (sqft)"
                            hide-details
                            append-icon="mdi-home"
                            return-masked-value
                        ></v-text-field>
                    </v-col>
                </v-row>
                <h5 class="text-h7 mb-1 mt-2 pa-0">Rent</h5>
                <v-row>
                    <v-col cols="6">
                    <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="form.rent_from"
                        prefix="£"
                        label="From"
                        hint="£"
                        return-masked-value
                    ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                    <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="form.rent_to"
                        label="To"
                        prefix="£"
                        hint="£"
                        return-masked-value
                    ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                :elevation="0"
                color="primary" @click="createEnquiry('exit')">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mask} from 'vue-the-mask'
    import CreateCompanyDialog from '@/components/companies/createCompanyDialog'
    import CreateUserDialog from '@/components/users/createUserDialog'
    import dateInput from '@/components/common/dateInput.vue'
    export default {
        components: {
            CreateCompanyDialog,
            CreateUserDialog,
            dateInput,
        },
        directives: {
            mask,
        },
        data() {
            return {
                entity: null,

                dialog: false,
                form: {
                    selectedCompany: null,
                    selectedContact: null,
                    stage: null,
                    reason: null,
                    received_at: null,
                    size_from: null,
                    size_to: null,
                    rent_from: null,
                    rent_to: null,
                },
                
                search: {
                    company: '',
                    contact: '',
                },

                Companies: [],
                Contacts: [],
                stage: '',
                stageOptions: [
                    {value: 'interest', label: 'Interest'},
                    {value: 'under_offer', label: 'Under Offer'},
                    {value: 'completed', label: 'Completed'},
                    {value: 'withdrawn', label: 'Withdrawn'},
                ],
                reason: null,
                reasonOptions: [
                    {value: 'new_store', label: 'New Store'},
                    {value: 'relocation', label: 'Relocation'},
                    {value: 'upsize', label: 'Upsize'},
                    {value: 'downsize', label: 'Downsize'},
                    {value: null, label: 'Unknown'},
                ],
                companiesLoading: false,
                contactsLoading: false,
                formErrors: {
                    companyContact: false,
                    stage: false,
                    reason: false,
                }
            }
        },
        methods: {
            closeDialog() {
                this.dialog = false;
            },
            openDialog(entity) {
                this.resetForm()
                
                this.entity = entity;

                this.dialog = true;
            },

            searchCompanies(prop){
                clearTimeout(this._timerId)
                this._timerId = setTimeout(() => {
                this.page = 1
                this.companiesLoading = true
                this.Companies = []
                this.getCompanies(prop)
                }, 500)
            },

            searchContacts(prop){
                clearTimeout(this._timerId)
                this._timerId = setTimeout(() => {
                this.page = 1
                this.contactsLoading = true
                this.Contacts = []
                this.getContacts(prop)
                }, 500)
            },

            async getCompanies(prop){
                this.formErrors.companyContact = false
                this.$http.get("/companies",{
                params: {
                    q: prop,
                    per_page: 50,
                }
                }).then(response => {
                this.Companies = response.data.data.map(company => {
                    return {
                    value: company.id,
                    label: company.name,
                    }
                })
                this.companiesLoading = false
                }).catch(error => {
                this.companiesLoading = false
                })
            },

            async getContacts(prop){
                this.formErrors.companyContact = false
                this.$http.get("/users",{
                params: {
                    q: prop,
                    per_page: 50,
                }
                }).then(response => {
                this.Contacts = response.data.data.map(contact => {
                    return {
                    value: contact.id,
                    label: contact.name,
                    }
                })
                this.contactsLoading = false
                }).catch(error => {
                this.contactsLoading = false
                })
            },

            validateForm(){
                let errors = false
                if(this.form.selectedCompany == null && this.form.selectedContact == null){
                this.formErrors.companyContact = true
                errors = true
                }
                if(this.form.stage == '' || this.form.stage == null){
                this.formErrors.stage = true
                errors = true
                }
                return !errors
            },

            async createEnquiry(exit){
                this.formErrors.stage = false
                this.formErrors.reason = false
                if (!this.validateForm()) return
                if(this.form.reason == null){
                    this.form.reason = 'unknown'
                }
                if(this.form.received_at == null){
                    // todays date
                    let today = new Date()
                    let dd = String(today.getDate()).padStart(2, '0');
                    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                    let yyyy = today.getFullYear();
                    this.form.received_at = dd + '/' + mm + '/' + yyyy;
                }
                this.$http.post("/enquiries",{
                    property_id: this.entity.type == 'property' ? this.entity.id : null,
                    scheme_id: this.entity.type == 'scheme' ? this.entity.id : null,
                    company_id: this.form.selectedCompany ? this.form.selectedCompany.value : null,
                    user_id: this.form.selectedContact ? this.form.selectedContact.value : null,
                    received_at: this.formatDate(this.form.received_at),
                    size_from: this.form.size_from,
                    size_to: this.form.size_to,
                    rent_from: this.form.rent_from,
                    rent_to: this.form.rent_to,
                    stage: this.form.stage,
                    reason: this.form.reason,
                }).then(response => {
                    // emit created with form
                    this.$emit('created', this.form)
                    this.dialog = false
                }).catch(error => {
                })
            },

            fillCompany(company){
                this.Companies.push({
                    value: company.id,
                    label: company.name,
                })
                this.form.selectedCompany = {
                    value: company.id,
                    label: company.name,
                }
            },

            fillContact(contact){
                this.Contacts.push({
                    value: contact.id,
                    label: contact.name,
                })
                this.form.selectedContact = {
                    value: contact.id,
                    label: contact.name,
                }
            },

            resetForm(){
                this.form = {
                    selectedCompany: null,
                    selectedContact: null,
                    stage: null,
                    reason: null,
                }
                this.formErrors = {
                    companyContact: false,
                    stage: false,
                    reason: false,
                }
            },

            formatLabel(value) {
                // split by - and take first part
                return value.split('-')[0]
            },

            formatDate(date){
                // change from DD/MM/YYYY to MM/DD/YYYY
                let dateArray = date.split('/')
                return dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2]
                
                
            },
        },
        computed: {
            checkCompanySearch(){
                return (this.Companies.length == 0 & !this.companiesLoading & (this.search.company && this.search.company.length > 0)) & !this.formErrors.companyContact & (!this.form.selectedCompany || typeof this.form.selectedCompany == 'string')
            },
            checkContactSearch(){
                return (this.Contacts.length == 0 & !this.contactsLoading & (this.search.contact && this.search.contact.length > 0)) & !this.formErrors.companyContact & (!this.form.selectedContact || typeof this.form.selectedContact == 'string')
            },
        }

    }

</script>